var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentsDisabled24DpE3E3E3Fill0Wght400Grad0Opsz24 = function SvgCommentsDisabled24DpE3E3E3Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160-240q-33 0-56.5-23.5T80-320v-447l-53-53 57-57L876-85l-57 57-212-212zm720 45L755-320h45v-480H275l-80-80h605q33 0 56.5 23.5T880-800zM160-320h367l-80-80H240v-80h127l-40-40h-87v-80h7l-87-87zm515-80-80-80h125v80zM555-520l-80-80h245v80zM435-640l-80-80h365v80zm80 80"
  })));
};
export default SvgCommentsDisabled24DpE3E3E3Fill0Wght400Grad0Opsz24;